import {
  AfterViewInit,
  Component,
  DOCUMENT,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  RendererFactory2,
  ViewChild,
  inject,
} from '@angular/core';
import { NativeSafeZoneService } from 'src/services/native-safe-zone.service';
import { NO_SCROLL_CLASS } from 'src/util/constants';

@Component({
  selector: 'liberro-mobile-bottom-overlay-sheet',
  standalone: false,
  templateUrl: './liberro-mobile-bottom-overlay-sheet.component.html',
  styleUrl: './liberro-mobile-bottom-overlay-sheet.component.less',
})
export class LiberroMobileBottomOverlaySheetComponent implements OnInit, AfterViewInit, OnDestroy {
  public nativeSafeZoneService = inject(NativeSafeZoneService);
  private document = inject<Document>(DOCUMENT);
  private renderer = inject(RendererFactory2).createRenderer(null, null);

  @Input() public maxHeight: string | null = null;
  @Output() public scrolledToBottom = new EventEmitter<void>();
  @Input() public customTopMargin: string = '';

  @ViewChild('scrollBody') private sheetRef?: ElementRef<HTMLElement>;

  private loadMoreLocked = false;
  private onSheetScroll = (): void => this.checkScrolledToBottom();

  public ngOnInit(): void {
    this.renderer.addClass(this.document.body, NO_SCROLL_CLASS);
  }

  public ngAfterViewInit(): void {
    this.sheetRef?.nativeElement.addEventListener('scroll', this.onSheetScroll, { passive: true });
  }

  public ngOnDestroy(): void {
    this.sheetRef?.nativeElement.removeEventListener('scroll', this.onSheetScroll);
    this.renderer.removeClass(this.document.body, NO_SCROLL_CLASS);
  }

  public unlockScrollLoad(): void {
    this.loadMoreLocked = false;
  }

  private checkScrolledToBottom(): void {
    if (this.loadMoreLocked) {
      return;
    }

    const element = this.sheetRef?.nativeElement;
    if (!element) {
      return;
    }

    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 24) {
      this.loadMoreLocked = true;
      this.scrolledToBottom.emit();
    }
  }
}
